/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  POST_DBS_FILES,
  GET_DBS_FILES_BY_FILE_ID,
  DELETE_DBS_FILES_BY_FILE_ID,
} from './actionTypes';

/**
 * Updates the details in the 'DocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postDbsFilesReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_DBS_FILES);

/**
 * Updates the indicator of creation of details in the 'DocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostDbsFilesReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_DBS_FILES);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postDbsFilesErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_DBS_FILES);

/**
 * Updates the details in the 'DocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const getDbsFilesByFileIdReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, GET_DBS_FILES_BY_FILE_ID);

/**
 * Updates the indicator of creation of details in the 'DocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetDbsFilesByFileIdReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, GET_DBS_FILES_BY_FILE_ID);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getDbsFilesByFileIdErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, GET_DBS_FILES_BY_FILE_ID);

/**
 * Updates the details in the 'DocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const deleteDbsFilesByFileIdReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, DELETE_DBS_FILES_BY_FILE_ID);

/**
 * Updates the indicator of creation of details in the 'DocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingDeleteDbsFilesByFileIdReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, DELETE_DBS_FILES_BY_FILE_ID);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const deleteDbsFilesByFileIdErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, DELETE_DBS_FILES_BY_FILE_ID);

const reducers = combineReducers({
  postDbsFiles: postDbsFilesReducer,

  isFetchingPostDbsFiles: isFetchingPostDbsFilesReducer,
  postDbsFilesError: postDbsFilesErrorReducer,

  getDbsFilesByFileId: getDbsFilesByFileIdReducer,

  isFetchingGetDbsFilesByFileId: isFetchingGetDbsFilesByFileIdReducer,
  getDbsFilesByFileIdError: getDbsFilesByFileIdErrorReducer,

  deleteDbsFilesByFileId: deleteDbsFilesByFileIdReducer,

  isFetchingDeleteDbsFilesByFileId: isFetchingDeleteDbsFilesByFileIdReducer,
  deleteDbsFilesByFileIdError: deleteDbsFilesByFileIdErrorReducer,
});

export default { reducers };
